var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-mast-container" },
    [
      _c(
        "flickity-slider",
        {
          ref: "slider",
          staticClass: "home-mast-slider",
          attrs: { options: _vm.sliderOptions }
        },
        _vm._l(_vm.slides, function(slide, idx) {
          return _c("div", { key: "hs-" + idx, staticClass: "carousel-cell" }, [
            _c("div", { staticClass: "inner-slide" }, [
              _c("div", { staticClass: "slide-image" }, [
                _c(
                  "a",
                  {
                    attrs: { href: slide.link.url, target: slide.link.target }
                  },
                  [
                    _c("img", {
                      attrs: { src: slide.image.sizes["1536x1536"] }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide-content" }, [
                _c("div", { staticClass: "slide-box" }, [
                  _c("div", { staticClass: "slide-body" }, [
                    _c("h4", {
                      domProps: { innerHTML: _vm._s(slide.headline) }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "slide-title",
                        attrs: {
                          href: slide.link.url,
                          target: slide.link.target
                        }
                      },
                      [
                        _c("h3", {
                          domProps: { innerHTML: _vm._s(slide.title) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { domProps: { innerHTML: _vm._s(slide.body) } }),
                    _vm._v(" "),
                    _c("a", {
                      staticClass: "learn-more",
                      attrs: {
                        href: slide.link.url,
                        target: slide.link.target
                      },
                      domProps: { innerHTML: _vm._s(slide.link.text) }
                    })
                  ])
                ])
              ])
            ])
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/HomeSlider.vue?vue&type=template&id=116772be&
// module id = 358
// module chunks = 0